export const servicesData = [
  {
    name: 'Pool Services',
    description: 'Complete pool maintenance, cleaning, and chemical balancing to keep your pool sparkling clean.',
    icon: 'ri-water-flash-line',
    bgColor: 'bg-blue-500'
  },
  {
    name: 'Gutter Cleaning',
    description: 'Professional gutter cleaning and maintenance to protect your home from water damage.',
    icon: 'ri-home-line',
    bgColor: 'bg-green-500'
  },
  {
    name: 'Pressure Washing',
    description: 'High-powered cleaning for driveways, sidewalks, decks, and exterior surfaces.',
    icon: 'ri-contrast-drop-line',
    bgColor: 'bg-orange-500'
  },
  {
    name: 'Junk Removal',
    description: 'Fast and efficient removal of unwanted items, debris, and clutter from your property.',
    icon: 'ri-delete-bin-line',
    bgColor: 'bg-red-500'
  },
  {
    name: 'Soft Washing',
    description: 'Gentle yet effective cleaning for delicate surfaces like roofs, siding, and painted areas.',
    icon: 'ri-drop-line',
    bgColor: 'bg-teal-500'
  },
  {
    name: 'Window Cleaning',
    description: 'Crystal-clear window cleaning for residential and commercial properties, inside and out.',
    icon: 'ri-window-line',
    bgColor: 'bg-cyan-500'
  },
  {
    name: 'Fence Staining',
    description: 'Professional fence staining and sealing to protect and beautify your wooden fences.',
    icon: 'ri-paint-brush-line',
    bgColor: 'bg-amber-600'
  },
  {
    name: 'Concrete Sealing',
    description: 'Protect your concrete surfaces from weather damage and stains with professional sealing.',
    icon: 'ri-road-map-line',
    bgColor: 'bg-gray-600'
  },
  {
    name: 'Outdoor Lighting',
    description: 'Installation and maintenance of outdoor lighting systems to enhance safety and aesthetics.',
    icon: 'ri-lightbulb-line',
    bgColor: 'bg-yellow-500'
  },
  {
    name: 'Solar Panel Cleaning',
    description: 'Maximize your solar panel efficiency with professional cleaning and maintenance.',
    icon: 'ri-sun-line',
    bgColor: 'bg-orange-400'
  },
  {
    name: 'Dryer Vent Cleaning',
    description: 'Prevent fire hazards and improve dryer efficiency with thorough vent cleaning.',
    icon: 'ri-fire-line',
    bgColor: 'bg-red-600'
  },
  {
    name: 'Trash Can Cleaning',
    description: 'Sanitize and deodorize your trash cans with our eco-friendly cleaning service.',
    icon: 'ri-recycle-line',
    bgColor: 'bg-green-600'
  }
];